import { Component, Input, OnInit } from '@angular/core';

interface Card {
    title: string;
    tooltipTitle?: string;
    issues: number;
    change?: number;
    changePercentage?: number;
}

interface VerticalData {
    verticalAverage: number;
    averageTitle: string;
    tooltipText: string;
    labels: string[];
}

@Component({
    selector: 'mon-chart-dashboard',
    templateUrl: './mon-chart-dashboard.component.html',
    standalone: false,
})
export class MonChartDashboardComponent implements OnInit {
    @Input() progress?: any;
    @Input() doughnutLabels!: string[];
    @Input() doughnutData!: number[];
    @Input() doughnutOptions?: any;
    @Input() doughnutColors?: any;

    @Input() lineLabels!: string[];
    @Input() lineData!: any[];
    @Input() lineOptions?: any;
    @Input() lineSeries!: string[];
    @Input() lineColors?: string[];
    @Input() lineOverride?: any;

    @Input() cards?: Card[];

    @Input() verticalData?: VerticalData;

    constructor () {}

    ngOnInit (): void {
        this.activate();
    }

    private activate (): void {
        this.cards = this.cards || [];
    }

    isNumber (val: any): boolean {
        return typeof val === 'number';
    }
}
